import { render, staticRenderFns } from "./EventAddV2.vue?vue&type=template&id=4145d972&scoped=true&"
import script from "./EventAddV2.vue?vue&type=script&lang=js&"
export * from "./EventAddV2.vue?vue&type=script&lang=js&"
import style0 from "./EventAddV2.vue?vue&type=style&index=0&id=4145d972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145d972",
  null
  
)

export default component.exports